import React from "react";
import './comp14.css';

class Comp14 extends React.Component {
  render() {
    return (
      <div className="comp14" data-part-id="container" size={2}>
        <h3 className="comp14_1" data-part-id="text" size={8}>
          We would like to see millions of people create their own website, with maintainable code in the background, and in whatever way is most natural for them.
        </h3>
      </div>
    );
  }
}

export default Comp14;
